import React, { FC } from 'react'
import { Box, Heading, Text, Stack } from '@chakra-ui/react'
import Image from 'next/image'

const Service: FC<OfferGlobal.Service> = ({ name, description, icon }) => (
  <Box
    w="full"
    bg="baseNeutral.700"
    rounded="md"
    p={6}
    borderRadius={10}
    overflow="hidden"
    h="27rem"
  >
    <Box h={{ base: '10rem', md: '11rem' }} pt={{ base: '4', md: '1.5rem' }} mt={-6} mx={-6} pos="relative" bgColor="white">
      <Image src={icon} alt={name} layout="fixed" width="125%" height="125%" loading="lazy" objectFit="contain" />
    </Box>

    <Stack textAlign="left" mt="m">
      <Heading
        as="h5"
        color="baseWhite"
        fontFamily="Montserrat-SemiBold"
        fontSize="0.875rem"
        letterSpacing="0.4px"
        textTransform="uppercase"
      >
        {name}
      </Heading>
      <Text
        color="baseWhite"
        fontFamily="Montserrat-Regular"
        fontSize="0.75rem"
        lineHeight="18pxpx"
        letterSpacing="0.2px"
        dangerouslySetInnerHTML={{ __html: description }}
      // dangerouslySetInnerHTML={{ __html: `Per essere sempre in regola e guidare in piena sicurezza<ul><li>Tutti gli interventi di controllo, riparazione e sostituzione degli pneumatici</li><li>Servizio di convergenza, equilibratura e controllo usura del battistrada</li><li>Su richiesta, sostituzione pneumatici invernali e/o estivo con supplemento di costo</li></ul>` }}
      />
    </Stack>
  </Box>
)

export default Service
